const SUBJECTS = ['profession', 'topics', 'audience', 'tone'];

// What an answer says: the chosen labels and own entries, the confirmed or written
// text, or null when skipped. The same mapping the backend uses for the profile.
export function answerValue(question, answer) {
  if (!answer || answer.kind === 'skip') return null;
  if (answer.kind !== 'choose') return answer.text;
  return [...answer.options.map(value => question.options.find(option => option.value === value)?.label).filter(Boolean), ...answer.custom].join(', ');
}

// Only what the creator confirmed or answered goes to the profile.
const profileRows = record => [
  record.account && { key: 'instagram', value: `@${record.account.handle}` },
  ...SUBJECTS.map(subject => {
    const question = record.questions.find(item => item.subject === subject);
    return { key: subject, value: question && answerValue(question, record.answers.find(answer => answer.question_id === question.id)) };
  }),
].filter(row => row && row.value);

// The onboarding conversation is derived from the resource, never stored as chat
// messages: the account the creator claimed, the analysis, each answered question
// with its answer, and the profile about to be created. The question being asked
// (and the memory question) lives in the composer, with its suggestion and options.
export default function useOnboardingThread(s) {
  const { t, onboarding: o } = s;
  const { record, stage } = o;
  const items = [];
  const say = (id, extra = {}) => items.push({ id, role: 'assistant', ...extra });
  const reply = (id, extra = {}) => items.push({ id, role: 'user', ...extra });
  if (record.account) reply('account', { kind: 'account' });
  if (stage === 'analyzing') say('analyzing', { kind: 'analyzing' });
  else {
    say('intro', { text: record.findings?.summary || t('onboardingIntroNoFindings') });
    for (const question of record.questions) {
      const answer = record.answers.find(item => item.question_id === question.id);
      if (!answer) break;
      say(`q-${question.id}`, { kind: 'question', question });
      reply(`a-${question.id}`, { kind: 'answer', question, answer, label: answerValue(question, answer) || t('onboardingSkipped'), skipped: answer.kind === 'skip' });
    }
    if (stage === 'memory' || stage === 'completing') say('summary', { kind: 'summary', rows: profileRows(record) });
  }
  return {
    items,
    // The orb asks from the composer once the questions start; here it only analyzes.
    orbFor: stage === 'analyzing' ? 'analyzing' : null,
    thinking: stage === 'analyzing' || stage === 'completing' || o.busy,
    editable: (stage === 'questioning' || stage === 'memory') && !o.busy,
  };
}
